import { render, staticRenderFns } from "./ClassDetailSection.vue?vue&type=template&id=77ffac41&scoped=true&"
import script from "./ClassDetailSection.vue?vue&type=script&lang=js&"
export * from "./ClassDetailSection.vue?vue&type=script&lang=js&"
import style0 from "./ClassDetailSection.vue?vue&type=style&index=0&id=77ffac41&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77ffac41",
  null
  
)

export default component.exports